import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import supportPrograms from "src/data/app/programs";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import * as actions from "src/redux/slices/programSlice";
import ProgramDocumentCard from "src/components/onboarding/program-documents/ProgramDocumentCard";
import Layout from "src/components/app/layout/Layout";
import Header from "src/components/app/layout/Header";
import Loader from "src/components/common/Loader";

const ProgramDocumentsScreen: React.FC = () => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const { patient } = useAppSelector((state) => state.auth);
  const { programRecords } = useAppSelector((state) => state.program);
  const dispatch = useAppDispatch();
  const [enableContinue, setEnableContinue] = useState(false);
  const [uploadedDocuments, setUploadedDocuments] = useState<any[]>([]);
  const navigate = useNavigate();
  const config =
    supportPrograms[supportProgramKey as keyof typeof supportPrograms];
  const requiredDocuments = config?.documents?.required_documents || [];

  useEffect(() => {
    getProgramRecords();
  }, []);

  useEffect(() => {
    if (requiredDocuments?.length > 0) {
      const uploadedDocuments = requiredDocuments?.map((document) => {
        const uploadedDocument = programRecords?.data?.filter(
          (programRecord) => programRecord?.title === document?.document_type
        );
        return {
          ...document,
          uploadedDocument:
            uploadedDocument?.length && uploadedDocument?.length > 0
              ? uploadedDocument[0]
              : null,
        };
      });
      const allRequiredDocsUploaded = uploadedDocuments?.every((document) =>
        document?.required && document?.uploadedDocument
          ? true
          : !document?.required
          ? true
          : false
      );
      //   setEnableContinue(allRequiredDocsUploaded);
      setEnableContinue(programRecords?.data?.length === 2);
      setUploadedDocuments(uploadedDocuments);
    }
  }, [requiredDocuments, programRecords]);

  const getProgramRecords = () => {
    const payload = {
      patient_id: patient?.data?.patient_id,
      report_type: config?.documents?.document_type,
    };
    new Promise((resolve, reject) => {
      dispatch(actions.getProgramRecordsRequest({ resolve, reject, payload }));
    });
  };

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <div className="relative pt-10 h-full">
        <div className="fixed top-0 left-0 right-0 z-10 max-w-lg mx-auto">
          <Header
            title="Program Documents"
            titlePosition="center"
            onBackClick={() => navigate(-1)}
          />
        </div>
        {programRecords?.isLoading ? (
          <div className="flex items-center justify-center h-full">
            <Loader size="lg" />
          </div>
        ) : (
          <div className="p-4 flex-1 h-full">
            <div className="my-4">
              <p className="text-[var(--text-secondary)]">
                {/* {description} */}
                Please upload the following documents to continue with the
                program
              </p>
            </div>

            <div className="flex flex-col gap-4">
              {uploadedDocuments?.map((document) => (
                <ProgramDocumentCard
                  className="bg-white"
                  docCardClassName="bg-gray-50"
                  key={document?.id}
                  documentData={document}
                  documentType={config.documents.document_type}
                  document={document?.uploadedDocument}
                  onSuccess={() => {
                    getProgramRecords();
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* <div className="border-t border-gray-200 p-4 fixed bottom-0 left-0 right-0 bg-white">
        <Button
          fullWidth
          onClick={handleContinue}
          disabled={!enableContinue}
          // className="mt-4"
        >
          <span className="flex items-center gap-2">
            Continue
            <ArrowRight className="w-4 h-4" />
          </span>
        </Button>
      </div> */}
      </div>
    </Layout>
  );
};

export default ProgramDocumentsScreen;
